<!--
 * @Author: zhangjingqing
 * @Date: 2022-05-29 19:49:04
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-08-18 21:12:22
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\views\user\RegisterModal.vue
-->
<template>
  <a-modal
      title="账号信息确认"
      :width="800"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      okText="确认"
      @ok="handleSave"
      @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-descriptions title="企业信息" :column="3"> </a-descriptions>
      <a-form-item label="企业名称">
        <a-input
            v-decorator="[
            'companyName',
            {
              rules: [{ required: true, message: '企业名称不能为空' }],
              trigger: 'blur',
            },
          ]"
            placeholder="请输入企业名称"
        />
      </a-form-item>


      <a-form-item label="纳税人性质">
        <a-select
            v-decorator="[
            'taxpayerNature',
            {
              rules: [{ required: true, message: '纳税人性质不能为空' }],
            },
          ]"
            placeholder="请选择纳税人性质"
        >
          <a-select-option
              v-for="item in taxpayerNature"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会计准则类型">
        <a-select
            v-decorator="[
            'indexStandardType',
            {
              rules: [{ required: true, message: '会计准则类型不能为空' }],
            },
          ]"
            placeholder="请选择会计准则类型"
        >
          <a-select-option
              v-for="item in indexStandardType"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="注册类型">
        <a-select
            v-decorator="[
            'registrationType',
            {
              rules: [{ required: true, message: '注册类型不能为空' }],
            },
          ]"
            placeholder="请选择注册类型"
        >
          <a-select-option
              v-for="item in registrationType"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="所属行业">
        <a-select
            v-decorator="[
            'industry',
            {
              rules: [{ required: true, message: '所属行业不能为空' }],
            },
          ]"
            placeholder="请选择所属行业"
        >
          <a-select-option
              v-for="item in industry"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import {mapActions} from "vuex";

const levelNames = {
  0: "低",
  1: "低",
  2: "中",
  3: "强",
};
const levelClass = {
  0: "error",
  1: "error",
  2: "warning",
  3: "success",
};
const levelColor = {
  0: "#ff0000",
  1: "#ff0000",
  2: "#ff7e05",
  3: "#52c41a",
};
import pick from "lodash.pick";
import { registerSiChuan } from "@/api/login";
import { initDynamicRoutes } from "@/router";

import {
  queryExtendFieldServiceList,
} from "@/api/tenant";
import {
  indexStandardType,
  taxpayerNature,
  industry,
  registrationType,
} from "@/utils/dict";
import { getQueryString } from "@/utils/utils";
export default {
  name: "RegisterModalSiChuan",
  data() {
    return {
      companyName: "",
      tokens:"",
      indexStandardType,
      taxpayerNature,
      industry,
      registrationType,
      visible: false,
      form: this.$form.createForm(this, { name: "form" }),
      confirmLoading: false,
      open: false,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      },
      expandFields: []
    };
  },
  mounted() {
     this.idToken = getQueryString("idToken");  // 获取 idToken 参数
    this.target = getQueryString("target");   // 获取 target 参数
  },
  methods: {
    async show() {
      await this.queryList();
      this.visible = true;
    },
    async queryList() {
      this.loading = true;
      let res = await queryExtendFieldServiceList({
        page: 1,
        pageSize: 100,
      });
      if (res.status == 200) {
        this.expandFields = res.data.rows;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    ...mapActions(["Login", "GetUserInfo"]),
    handleSave() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let params = Object.assign(
              {},
              pick(
                  values,

                  "companyName",
                  "indexStandardType",
                  "taxpayerNature",
                  "industry",
                  "taxpayerType",
                  "registrationType",

              ),
          );
          params.type = 2;
          params.idToken = this.idToken;  // 使用从 URL 获取的 idToken
          params.target = this.target;   // 使用从 URL 获取的 target
          let res = await registerSiChuan(params);
          if (res.status == 200) {
            const userData = res.data; // 红莓返回的用户信息在 data.data 里
            let id = userData.userId; // 红莓返回的用
            let token = userData.token; // 红莓返回的登录账号（文档字段：data.userAccount）
            const formData = new FormData();
            formData.append('email',id);
            formData.append('token', token);
            this.Login(formData).then(async () => {
              let res = await this.GetUserInfo();
              initDynamicRoutes();
              if (res.data.tenantId) {
                this.$router.push("/taxRiskControl");
              } else {
                this.$router.push("/dashboard");
              }
              this.$notification.success({
                message: "欢迎"
              });
            }).catch((err) => {
              this.$message.error(err.msg);
            });
          } else {
            let msg = res.msg || res.message;
            let len = msg.length;
            this.$notification.error({
              message: "系统提示",
              description: len > 100 ? "系统错误，请联系管理员" : msg,
              duration: 4,
            });
          }
        }
      });
    },
    handleCancel() {
      this.state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      };
      this.form.resetFields();
      this.visible = false;
    },

  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    },
  },
};
</script>
<style lang="less" scoped>
</style>
